module.exports = __webpack_public_path__ + "static/media/upload-icon.0f6d653d.svg";